<template>
	<div>
		<swiper
			:modules="modules"
			:slides-per-view="1"
			:space-between="10"
			:pagination="{ clickable: true }"
			navigation
			:breakpoints="{ 1024: { slidesPerView: 2 } }"
			:loop="meals.length > 2"
			class="mySwiper p-2"
			v-if="meals.length">
			<swiper-slide v-for="meal in meals" :key="meal.id">
				<div class="meal-card" @click="selectMealCard(meal)">
					<div class="meal-image-container">
						<!-- <img
							:src="getImageSource(meal.img)"
							alt="Meal image"
							class="meal-image" /> -->
						<image-loader
							:src="getImageSource(meal.img)"
							alt="Meal image"
							class="meal-image" />
						<allergy :meal="meal" />
						<div class="rating-container">
							<rating-gauge
								class="rating-gauge"
								width="80"
								:rating="+meal.rating"
								v-if="meal.rating" />
						</div>
					</div>
					<div class="meal-info">
						<h3>
							{{ getName(meal) }}
						</h3>
						<div class="d-flex align-item-center justify-content-between gap-5">
							<div
								v-if="meal.cook_type && meal.meal_type"
								class="flex-shrink-0">
								<span
									class="badge me-2"
									:class="[getCookTypeColor(meal.cook_type)]"
									>{{ meal.cook_type }}</span
								><span
									class="badge"
									:class="[getMealTypeColor(meal.meal_type)]"
									>{{ meal.meal_type }}</span
								>
							</div>
							<div v-if="meal.restaurant_name">
								<div class="d-flex align-items-center">
									<i class="bi bi-geo-alt-fill me-2"></i>
									<span>{{ meal.restaurant_name }}</span>
								</div>
							</div>
						</div>
						<p>
							{{ getDescription(meal) }}
						</p>
						<p>
							Calories:
							{{ meal.entry.nutritional_info.calories }}
						</p>
						<small>{{ formatTimestamp(meal.timestamp) }}</small>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div v-else>
			<h3 class="text-center p-5">Nothing to see.</h3>
		</div>
		<food-detail-modal
			:meal="selectedMeal"
			:show="showFDM"
			@close="closeModal" />
	</div>
</template>

<script setup>
	import { ref, watch, onBeforeMount, onBeforeUnmount } from "vue"
	import { Swiper, SwiperSlide } from "swiper/vue"
	// import Swiper core and required modules
	import { Navigation, Pagination, Autoplay } from "swiper/modules"
	import FoodDetailModal from "./FoodDetailModal.vue"
	import moment from "moment-timezone"
	import RatingGauge from "./RatingGauge.vue"
	// import { lastMealUpdated } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import {
		getDescription,
		getName,
		getImageSource,
		getCookTypeColor,
		getMealTypeColor,
	} from "../utils/mealLib"
	import ImageLoader from "@/components/ImageLoader.vue"
	import Allergy from "./Allergy.vue"

	const props = defineProps(["meals"])

	const modules = ref([Navigation, Pagination, Autoplay])
	const showFDM = ref(false)
	const selectedMeal = ref(null)

	function closeModal() {
		selectedMeal.value = null
		showFDM.value = false
	}

	function selectMealCard(meal) {
		selectedMeal.value = meal
		showFDM.value = true
	}

	function formatTimestamp(timestamp) {
		return moment.unix(timestamp).format("MM/DD/YYYY hh:mm a")
	}

	let muEvent = null
	onBeforeMount(() => {
		// console.log("mounting swiper")
		muEvent = EventBus.on("meal-updated", (updatedMeal) => {
			if (!updatedMeal) return
			//check to see if the new one that updated is our id and if it is, updated it
			if (selectedMeal.value && selectedMeal.value.id === updatedMeal.id) {
				selectedMeal.value = updatedMeal
			}
		})
	})

	onBeforeUnmount(() => {
		// console.log("unmounting swiper")
		if (muEvent) muEvent()
	})

	// watch(lastMealUpdated, (v) => {
	// 	if (!v) return
	// 	//check to see if the new one that updated is our id and if it is, updated it
	// 	if (selectedMeal.value && selectedMeal.value.id === v.id) {
	// 		selectedMeal.value = v
	// 	}
	// })
</script>

<style lang="less" scoped>
	.swiper-container {
		width: 100%;
		// padding-top: 20px;
		// padding-bottom: 50px;
		height: auto;
	}

	.mySwiper {
		::v-deep(> div) {
			// display: flex;
			// flex-direction: row;

			.swiper-slide {
				height: auto;
			}
		}
	}

	.meal-card {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		background-color: #fff;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		margin-bottom: 1rem;
	}

	.meal-image-container {
		position: relative;
		.allergy-container {
			position: absolute;
			bottom: 10px;
			left: 10px;
		}
		.rating-container {
			background: rgba(0, 0, 0, 0.3);
			position: absolute;
			bottom: 10px;
			right: 10px;
		}
	}

	.meal-image {
		::v-deep(> img) {
			width: 100%;
			height: auto;
			aspect-ratio: 16 / 9;
			object-fit: cover;
			// transform: rotateZ(90deg);
		}
	}

	.meal-info {
		padding: 1rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
	}

	.small {
		font-size: 0.8rem;
	}
</style>
